import { AttributesMixin, define, Model } from "@type-r/models";
import { UserEntitlementCatalogValue } from "src/app/models/UserEntitlements";
import { AssetEventType, GenericExternalSystemType } from "./assetEvent";
import { restfulIO } from "./endpoint";

export enum ExternalSystemType {
    none = '',
    scf = 'scf',
    ar = 'ar',
    inblock = 'inblock'
}

export class ExternalSystem {
    title: string;
    description: string;
    icon: string;
    type?: string;
    assetEventType?: AssetEventType;
    externalSystemType?: GenericExternalSystemType;
    failMessage?: string;
    successMessage?: string;
    waitingMessage?: string;
    globalFailMessage?: string;
    globalSuccessMessage?: string;
    requiredPermission?: UserEntitlementCatalogValue;
}

export interface ExternalSystemRequest extends AttributesMixin<typeof ExternalSystemRequest> { }
@define
export class ExternalSystemRequest extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/externalSystemRequest');

    static attributes = {
        to: String,
        assetType: String,
        assetUids: [String],
        facilityIds: [Number],
        programId: Number,
        importJobId: Number
    };
}
